// api/config.js
export default {
    baseUrl: {
        dev: '/api' // 开发环境
        // dev: 'http://xxx.xx.xx.xx:8080'
        // pro: "http://production.com" 生产环境
    }
}
